import { IPendingEverifyRepository } from '../ports/outbound/IPendingEverifyRepository';
import { DelayReasonRequest } from '../domain/entities/DelayReasonRequest';

/**
 * Answers the one refusal the employer can clear from the case screen: E-Verify turns down a case
 * raised more than three business days after the first day of employment unless it states why.
 * The API records the reason and files the case again in the same call.
 */
export class RecordDelayReasonUseCase {
  constructor(private readonly repository: IPendingEverifyRepository) {}

  async execute(everifyCaseQueueId: string, request: DelayReasonRequest): Promise<void> {
    return this.repository.recordDelayReason(everifyCaseQueueId, request);
  }
}
